// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton-module__linkButton--bfaYA"};